import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";

const ProductCard = ({ product }) => {
  const { addToCart } = useContext(CartContext);

  return (
    <div className="product-card">
      <img
        src={product.thumbnail || product.images?.[0]}
        alt={product.title}
      />

      <h3>{product.title}</h3>

      <p>
        {product.description.length > 60
          ? product.description.substring(0, 60) + "..."
          : product.description}
      </p>

      <div className="price">${product.price}</div>

      <button onClick={() => addToCart(product)}>
        Add to Cart
      </button>
    </div>
  );
};

export default ProductCard;